module.exports = __webpack_public_path__ + "media/src/assets/images/double-quote-be3f1353aeee5648482024041da7fa6a.svg";